import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import axios from "axios";
import Swal from "sweetalert2";
import { getAuthCredentials } from "../../../utils/auth";

const HandleArchiveItem = ({ item, onClose, onArchiveConfirm }) => {
  const { token } = getAuthCredentials();

  const handleConfirmArchive = async () => {
    const { inventoryId, instanceIndex, isMainInventory } = item;

    if (!inventoryId) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Missing inventory ID. Cannot archive the item.",
      });
      return;
    }

    try {
      if (isMainInventory) {
        const response = await axios.post(
          `${process.env.REACT_APP_BACKEND_URL}/v1/api/inventory/archive`,
          { inventoryId },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        Swal.fire({
          icon: "success",
          title: "Success!",
          text: `Main Inventory Item ${item.inventoryName} archived successfully.`,
        });

        onArchiveConfirm();
      } else {
        await axios.post(
          `${process.env.REACT_APP_BACKEND_URL}/v1/api/inventory/archive-instance`,
          { inventoryId, instanceIndex },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        Swal.fire({
          icon: "success",
          title: "Success!",
          text: `Instance from ${item.inventoryName} archived successfully.`,
        });

        onArchiveConfirm();
      }
    } catch (error) {
      const err = error.response?.data;
      const currentMenu = err?.currentMenuItems || [];
      const archivedMenu = err?.archivedMenuItems || [];

      if (currentMenu.length > 0 || archivedMenu.length > 0) {
        onClose(); // Close dialog first

        setTimeout(() => {
          Swal.fire({
            icon: "warning",
            title: "Cannot Archive",
            html: `
              <p><strong>${
                item.inventoryName
              }</strong> is still being used in:</p>
              ${
                currentMenu.length > 0
                  ? `
                <h4 style="text-align:left;">Current Menu</h4>
                <ul style="text-align:left; max-height:120px; overflow-y:auto;">
                  ${currentMenu.map((name) => `<li>${name}</li>`).join("")}
                </ul>
              `
                  : ""
              }
              ${
                archivedMenu.length > 0
                  ? `
                <h4 style="text-align:left; margin-top:10px;">Archived Menu</h4>
                <ul style="text-align:left; max-height:120px; overflow-y:auto;">
                  ${archivedMenu.map((name) => `<li>${name}</li>`).join("")}
                </ul>
              `
                  : ""
              }
              <p>Please remove it from these menus before archiving.</p>
              <p>if you wish to change/remove the stock, kindly <b>archive the Inventory's Stock.</b></p>
            `,
            width: 600,
          });
        }, 300);
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: `Failed to archive ${item.inventoryName}. Please try again.`,
        });
      }

      console.error("Error archiving item:", error);
    }
  };

  return (
    <Dialog open={true} onClose={onClose} fullWidth>
      <DialogTitle>
        Archive {item.isMainInventory ? "Main Inventory Item" : "Instance"}
      </DialogTitle>
      <DialogContent>
        <Typography>
          Are you sure you want to archive{" "}
          {item.isMainInventory ? (
            <strong>the main inventory item</strong>
          ) : (
            <strong>this instance</strong>
          )}{" "}
          of <strong>{item.inventoryName}</strong>?
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          Cancel
        </Button>
        <Button onClick={handleConfirmArchive} color="primary">
          Archive
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default HandleArchiveItem;
